import "jquery";
import inputmask from 'inputmask/dist/jquery.inputmask.bundle'
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import './external_modules/angular-circular-progress-master/circularProgress';
import 'angular1-text-mask/dist/angular1TextMask';
import NumberService from './services/NumberService';
import CalculatorService from './services/CalculatorService';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import 'normalize.css';


import './common/css/bootstrap.min.css'
import './common/css/style.css'
import './common/css/animate.min.css'
import './common/css/font-awesome.min.css'


angular.module('app', [
    uiRouter,
    'angular-circular-progress',
    'text-mask',
    Common,
    Components,
  ])
  // .config(($locationProvider) => {
  //   "ngInject";
  //   // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  //   // #how-to-configure-your-server-to-work-with-html5mode
  //   $locationProvider.html5Mode(true).hashPrefix('!');
  // })
  .factory('NumberService', NumberService)
  .factory('CalculatorService', CalculatorService)
  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js